import { ArrowUpRight, BookOpen, Images, Star } from "lucide-react";
import { EncabezadoSeccion, Reveal, Marquee } from "../../shared/motion";

export function EnlacesSeccion({ datos, seccion }) {
  const enlaces = datos.enlaces || [];
  if (enlaces.length === 0) return null;

  return (
    <section className="kx-seccion" aria-label={seccion.titulo}>
      <div className="kx-seccion-interior">
        <EncabezadoSeccion p="kx" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="kx-titulo-enlaces" />
        <Reveal>
          <div className="kx-enlaces">
            {enlaces.map((enlace, i) => (
              <a
                key={i}
                className="kx-boton"
                href={enlace.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`kx-enlace-adicional-${i}`}
              >
                {enlace.texto}
                <ArrowUpRight strokeWidth={2} />
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function AccesosSeccion({ datos, seccion, acciones }) {
  const accesos = datos.accesos || {};
  const items = [
    accesos.libroFirmas && {
      icono: BookOpen,
      datos: accesos.libroFirmas,
      alHacer: acciones?.onAbrirLibroFirmas,
      testid: "kx-boton-libro-firmas",
    },
    accesos.album && {
      icono: Images,
      datos: accesos.album,
      alHacer: acciones?.onAbrirAlbumColaborativo,
      testid: "kx-boton-album",
    },
  ].filter(Boolean);
  if (items.length === 0) return null;

  return (
    <section className="kx-seccion" aria-label={seccion.titulo}>
      <div className="kx-seccion-interior">
        <EncabezadoSeccion p="kx" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="kx-titulo-accesos" />
        <Reveal>
          <div className="kx-accesos">
            {items.map((item, i) => (
              <button key={i} type="button" className="kx-acceso" onClick={() => item.alHacer?.()} data-testid={item.testid}>
                <item.icono strokeWidth={2} />
                <span>
                  <span className="kx-acceso-titulo">{item.datos.titulo}</span>
                  <span className="kx-acceso-texto" style={{ display: "block" }}>
                    {item.datos.texto}
                  </span>
                </span>
              </button>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function CierreSeccion({ datos }) {
  const { protagonista, evento, legal } = datos;

  return (
    <>
      <Marquee
        p="kx"
        textos={[protagonista.nombre, `${protagonista.edad} ${protagonista.textoEdad || "años"}`, evento.fechaCorta, evento.ciudad]}
      />
      <section className="kx-seccion kx-cierre" data-testid="kx-cierre">
        <div className="kx-seccion-interior">
          <Reveal>
            <Star className="kx-cierre-estrella" strokeWidth={1.8} fill="currentColor" aria-hidden="true" />
            <p className="kx-cierre-mensaje">{protagonista.mensajeCierre}</p>
            <p className="kx-cierre-nombre">{protagonista.nombre}</p>
            <div className="kx-cierre-legal">
              <span>{legal?.marca}</span>
              {legal?.urlPrivacidad && (
                <a href={legal.urlPrivacidad} target="_blank" rel="noopener noreferrer" data-testid="kx-enlace-privacidad">
                  {legal.textoPrivacidad || "Privacidad"}
                </a>
              )}
              {legal?.urlCondiciones && (
                <a href={legal.urlCondiciones} target="_blank" rel="noopener noreferrer" data-testid="kx-enlace-condiciones">
                  {legal.textoCondiciones || "Condiciones"}
                </a>
              )}
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
